<!--  -->
<template>
  <div class="box">
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>质量专家</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-bar">
        <el-input
            v-model="keyword"
            placeholder="请输入关键字"
            class="search-input"
            @keyup.enter.native="getData"
            clearable
            @clear="getData"
        >
        <template slot="append">
            <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
        </template>
        </el-input>
    </div>

      <div style="padding-top:10px;">
        <!-- 专业领域筛选 -->
        <div class="filter-group">
            <span class="filter-label">专业领域</span>
            <el-radio-group v-model="professionalFieldId" class="radio-group"  @change="getData">
                <el-radio-button 
                :label="item.value" 
                v-for="item in professionalList" 
                :key="item.value"
                >
                {{ item.text }}
                </el-radio-button>
            </el-radio-group>
        </div>
      </div>

    <div class="content">
        <div class="top">
            <img src="../../assets/img/jiliangnengli/icon.png" alt="">
            <div class="title">专家库</div>
        </div>
        <div class="list">
            <div class="item" v-for="(item, index) in talentsList" :key="item.id">
                <div v-if="item.photo != null">
                    <img class="avatar" :src="downloadUrl + item.photo" alt="">
                </div>
                <div v-else>
                    <img class="avatar" src="../../assets/img/talents/talents-avatar.png" alt="">
                </div>
                <!-- <img class="avatar" :src="item.photo ? (downloadUrl + item.photo) : '../../assets/img/talents/talents-avatar.png'" alt=""> -->
                <div class="item-content">
                    <div class="name">姓名：{{ item.name }}</div>
                    <div class="info">
                        <div class="info-desc">
                            <div>工作单位: </div>
                            <div style="flex: 1;margin-left: 10px;">{{ item.workUnit }}</div>
                        </div>
                        <div class="info-desc" style="margin-left: 20px;">
                            <div>职称: </div>
                            <div style="flex: 1;margin-left: 10px;">{{ item.positionalTitles }}</div>
                        </div>
                        <div class="info-desc">
                            <div>专业领域: </div>
                            <div style="flex: 1;margin-left: 10px;">{{ item.professionalField }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom">
            <el-pagination
                layout="prev, pager, next"
                :total="talentTotal"
                @current-change="onCurrentChange"
                @prev-click="prePage"
                @next-click="nextPage"
                :page-size="pageSize"
            >
            </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import { Server, httpurl } from '@/server';
export default {
  data () {
    return {
        keyword: "",
        // 专业领域数组
        professionalList: [
        { value: 'all', text: '全部' },
        { value: '标准化', text: '标准化' },
        { value: '计量', text: '计量' },
        { value: '信息化', text: '信息化' },
        { value: '特种设备安全', text: '特种设备安全' },
        { value: '食品安全', text: '食品安全' },
        { value: '药械化安全', text: '药械化安全' },
        { value: '产品质量安全', text: '产品质量安全' }
        ],
        professionalFieldId: 'all', // 默认选中 检验检测 的 id

        talentsList: [], // 专家列表
        downloadUrl: '',

        pageSize: 10,
        pageNo: 1,

        talentTotal: 0
    }
  },
  created() {
    this.getData()
    this.downloadUrl = this.$downloadUrl
  },
  methods: {
    getData() {
        let name = "*" + this.keyword + "*"
        const pId = this.professionalFieldId=='all'?'':this.professionalFieldId
        Server.getTalentsTrainInfo({pageNo: this.pageNo, pageSize: 10, name: name, professionalField: pId}).then(res => {
            console.log(res);
            if(res.success) {
                this.talentTotal = res.result.total
                this.talentsList = res.result.records
            }
            
        })
    },

    onCurrentChange(page) {
        this.pageNo = page
        this.getData()
    },
    prePage() {
        this.pageNo = this.pageNo - 1;
        this.getData()
    },
    nextPage() {
        this.pageNo = this.pageNo + 1;
        this.getData()
    },
  }
}
</script>

<style lang="less" scoped>
    .search-bar {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 700px; /* 可根据你的页面调整宽度 */
        padding-top: 20px;
    }

    .search-input {
        flex: 1;
    }

    /* 调整输入框和按钮的样式，和截图视觉一致 */
    ::v-deep .el-input-group__append {
        // background-color: #409eff;
        // border-color: #409eff;
        // border-radius: 0 20px 20px 0; /* 右边圆角 */
        padding: 0;
    }

    ::v-deep .el-input-group__append .el-button {
        background-color: #409eff;
        // border: none;
        color: #fff;
        // padding: 0 20px;
        border-radius: 0 20px 20px 0;
        height: 38px !important;
    }

    ::v-deep .el-input__inner {
        border-radius: 20px 0 0 20px; /* 左边圆角 */
        border-right: none;
        padding: 0 30px !important;
    }
    ::v-deep .el-input__clear {
        margin-right: 25px;
    }
    /* 筛选组 */
    .filter-group {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 5px 0;
        padding: 0 10px
    }

    .filter-label {
        color: #696969;
        margin-right: 15px;
        white-space: nowrap;
        font-size: 13px;
    }

    ::v-deep .el-radio-button__inner {
        background-color: transparent;
        border: none;
        color: #333;
        padding: 8px 15px;
        font-size: 13px;
    }

    ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #0371FF;
        color: #fff;
        border-radius: 15px;
    }

    /* 关掉 el-radio-button 所有过渡动画 */
    ::v-deep .el-radio-button__inner {
        transition: none !important;
    }
    ::v-deep .el-radio-button__inner::after {
        transition: none !important;
    }
    .content {
        margin: 30px 0 80px;
        background-color: #fff;
        padding: 10px;
        .top {
            display: flex;
            align-items: center;
            padding: 15px 0;
            border-bottom: 1px solid #ccc;
            img {
                width: 40px;
                height: 40px;
                margin: 0 15px;
            }
            .title {
                font-size: 24px;
                font-weight: bold;
                color: #1677ff;
            }
        }
        .list {
            width: 100%;
            // height: ;

            padding: 50px 30px;
    
            .item {
                display: flex;
                margin-bottom: 30px;
                padding: 20px;
                box-sizing: border-box;
                // border: 1px solid #ccc;
                box-shadow: 0 0 10px #ccc;
                .avatar {
                    width: 100px;
                    height: 100px;
                    margin-right: 30px;
                }
                .item-content {
                    flex: 1;
                    .name {
                        font-weight: bold;
                        font-size: 22px;
                        line-height: 40px;
                    }
                    .info {
                        display: flex;
                        flex-wrap: wrap;
                        .info-desc {
                            width: 45%;
                            color: #999;
                            line-height: 40px;

                            display: flex;
                        }
                    }
                }
            }
        }

        .bottom {
            display: flex;
            justify-content: center;

            padding-bottom: 20px;
        }
        &:hover {
            box-shadow: 0 0 15px #ccc;
        }
    }
</style>
